import { Image, Container, Title, Button, Group } from '@mantine/core';
import { Link } from 'react-router';
import classes from './Style.module.css';
import { useEffect } from 'react';
import { useStore } from '@/store';
import image from './404.svg'
import { translate } from '@/lib';

const PageNotFound = () => {

  const { userLoaded } = useStore()

  useEffect(() => {
    if(userLoaded) {
    }
  }, [userLoaded])

  return (
    <Container className={classes.root}>
      <div className={classes.inner}>
        <Image src={image} className={classes.desktopImage} />
        <br/><br/>
        <div className={classes.content}>
          <Title ta={'center'} className={classes.title}>{translate('ff.pageNotFound.title', 'Page not found')}</Title>
          <Group justify="center">
            <Button to={'/'} style={{color: '#fff'}} size="md" component={Link}>{translate('ff.pageNotFound.backToHome', 'Back to home')}</Button>
          </Group>
        </div>
      </div>
    </Container>
  );
}

export default PageNotFound